import React from "react";

const SpecsCardMain = ({ HorizontalAdjustment, VerticalAdjustment }) => {
  return (
    <div className="md:px-20 text-sm text-gray-800 bg-white rounded py-5 w-full flex justify-around gap-4 lg:flex-row flex-col">
      <div className="0 p-4 text-left rounded flex bg-red-50 md:w-96">
        <p className="font-bold">Cart base</p>
      </div>
      <div className="p-4 text-left rounded flex bg-red-200 w-full">
        <p className="font-bold mx-5">Horizontal adjustment : </p>
        <p>30</p>
      </div>
    </div>
  );
};

const DisplayData = ({ data }) => {
  return (
    <div>
      {data.map((item, index) => (
        <div
          key={index}
          className="md:px-10 text-sm text-gray-800 bg-white rounded py-5 w-full flex justify-around gap-4 lg:flex-row flex-col border"
        >
          {Object.entries(item).map(([key, value]) => (
            <div
              key={key}
              className="p-4 text-left items-start rounded flex flex-row w-full"
            >
              <div className="w-1/3">
                <p className="font-bold">{key}</p>
              </div>
              <div className="flex flex-col w-2/3 ">
                {Array.isArray(value) ? (
                  value.map((innerValue, innerIndex) => (
                    <div
                      key={innerIndex}
                      className="text-left rounded flex flex-col w-full"
                    >
                      {Object.entries(innerValue).map(
                        ([propKey, propValue]) => (
                          <p key={propKey} className="mb-1">
                            <span className="font-bold">{propKey} : </span>{" "}
                            {propValue}
                          </p>
                        )
                      )}
                    </div>
                  ))
                ) : (
                  <div className="p-4 text-left rounded flex flex-col w-full">
                    {Object.entries(value).map(([propKey, propValue]) => (
                      <p key={propKey} className="mb-1">
                        <span className="font-bold">{propKey} : </span>{" "}
                        {propValue}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const SpecsCardOptions = ({ title, Discription }) => {
  return (
    <div className="md:px-10 bg-[#F3F3F3] text-sm text-gray-800 rounded py-5 w-full flex justify-evenly gap-4 md:flex-row flex-col">
      <div className="0 p-4 text-left rounded flex-1">
        <p className="font-bold">{title}</p>
      </div>
      <div className=" p-4 text-left rounded flex-1">
        <p>{Discription}</p>
      </div>
      <div className=" p-4 text-left rounded flex-1"></div>
    </div>
  );
};

const SpecsTab = ({ mainSpec, Options }) => {
  return (
    <div className="py-5 ">
      {/* <SpecsCardMain HorizontalAdjustment={Horizontaladjustment} VerticalAdjustment={Verticaladjustment}/> */}
      {/* {Options.length > 0 ? (
        Options.map((option, index) => (
          <SpecsCardOptions
            key={index}
            title={option.title}
            Discription={option.description}
          />
        ))
      ) : (
        <>
        <SpecsCardOptions
            title={Options.title}
            Discription={Options.description}
          />
          
          <DisplayData data={Options} />

          </>
      )} */}
      <SpecsCardOptions title={mainSpec}/>
      <DisplayData data={Options} />
    </div>
  );
};

export default SpecsTab;
